// @ts-nocheck
/**
 * Bundle Product Customizer V2 - Minimal Implementation
 * Extends BaseCustomizer with only bundle-specific logic
 */

class BundleProductCustomizer extends BaseCustomizer {
  constructor(customizerElement) {
    super({
      selectors: {
        customizer: '[data-bundle-customizer]',
        form: 'form[action="/cart/add"]',
        addToCartButton: '[name="add"]',
        variantInput: '[name="id"]',
        quantityInput: '[name="quantity"]',
        priceContainer: '.price'
      },
      autoInit: false
    });

    this.customizerElement = customizerElement;
    this.productId = null;
    this.parentSectionId = null;
    this.bundleModules = null;
    this.modules = new Map();
    this.extraVariantsSelections = new Map();
    this.sessionStorageKey = null;
    this.originalPriceContainerHTML = null;
    this.currentOpenAccordion = null;
    this._isAddingBundleToCart = false;

    this.initializeBundle();
  }

  initializeBundle() {
    this.customizer = this.customizerElement || document.querySelector(this.config.selectors.customizer);
    if (!this.customizer) return;

    this.productId = this.customizer.dataset.productId;
    this.parentSectionId = this.customizer.dataset.parentSectionId;
    this.bundleModules = this.customizer.querySelector('[data-bundle-modules]');
    this.sessionStorageKey = `bundle-customizer-${this.productId}`;

    if (!this.bundleModules) return;

    if (this.initialize()) {
      this.initializeBundleSpecific();
      this.customizer._bundleCustomizerInstance = this;
    }
  }

  findElements() {
    this.productForm = document.querySelector(`#product-form-${this.parentSectionId}`) ||
      document.querySelector('form[action="/cart/add"]');
    if (!this.productForm) return false;

    this.addToCartButton = this.productForm.querySelector('[name="add"]') ||
      document.querySelector('[name="add"]');
    this.variantIdInput = this.productForm.querySelector('[name="id"]');
    this.quantityInput = this.productForm.querySelector('[name="quantity"]');

    // More specific price container targeting to avoid conflicts with theme price
    this.priceContainer = document.getElementById(`price-${this.parentSectionId}`) ||
      document.querySelector('product-price [ref="priceContainer"]') ||
      document.querySelector('.price__container') ||
      document.querySelector('.price');

    // Sticky price container
    this.stickyPriceContainer = document.querySelector('.sticky-add-to-cart__price') ||
      document.querySelector('[data-testid="sticky-price-display"]');

    return !!(this.addToCartButton && this.variantIdInput);
  }

  initializeBundleSpecific() {
    if (this.priceContainer) {
      this.originalPriceContainerHTML = this.priceContainer.innerHTML;
    }

    if (this.stickyPriceContainer) {
      this.originalStickyPriceContainerHTML = this.stickyPriceContainer.innerHTML;
    }

    if (this.addToCartButton && !this.addToCartButton.dataset.originalHtml) {
      this.addToCartButton.dataset.originalHtml = this.addToCartButton.innerHTML;
    }

    this.bindBundleEvents();
    this.initializeModules();
    this.loadModuleState();
    this.updateMainProductPrice();
    this.updateAddToCartButtonState();

    // Re-apply price update after theme variant updates (fix for sticky-add-to-cart)
    document.addEventListener('variant:update', (event) => {
      if (event.detail.data?.productId && this.productId && event.detail.data.productId.toString() === this.productId.toString()) {
        setTimeout(() => this.updateMainProductPrice(), 50);
      }
    });
  }

  bindBundleEvents() {
    // Override BaseCustomizer click handling for bundle modules
    if (this.bundleModules && this.boundHandlers.has('clickHandler')) {
      // Remove BaseCustomizer's click handler from the customizer element
      this.customizer.removeEventListener('click', this.boundHandlers.get('clickHandler'));
    }

    this.bundleModules.addEventListener('click', (event) => {
      const quantityBtn = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
      if (quantityBtn) {
        event.preventDefault();
        this.handleQuantityButtonClick(event);
        return;
      }

      const addToBundle = event.target.closest('[data-add-to-bundle]');
      if (addToBundle) {
        event.preventDefault();
        this.handleAddToBundleClick(event);
        return;
      }

      const removeBtn = event.target.closest('[data-remove-from-bundle]');
      if (removeBtn) {
        event.preventDefault();
        this.handleRemoveFromBundleClick(event);
        return;
      }

      const designBtn = event.target.closest('[data-module-design]');
      if (designBtn) {
        event.preventDefault();
        this.toggleAccordion(designBtn.closest('.bundle-product-module').dataset.moduleHandle);
        return;
      }

      const moduleHeader = event.target.closest('.module-header');
      if (moduleHeader && !event.target.closest('button')) {
        event.preventDefault();
        this.handleModuleHeaderClick(event);
        return;
      }

      const dropdownToggle = event.target.closest('[data-dropdown-toggle]');
      if (dropdownToggle) {
        event.preventDefault();
        this.handleDropdownToggle(event);
        return;
      }

      const moduleOption = event.target.closest('.module-option');
      if (moduleOption && !event.target.matches('input[type="radio"]')) {
        const radio = moduleOption.querySelector('.variant-radio, .extra-variant-radio');
        if (radio) {
          radio.checked = true;
          this.handleVariantRadioChange(radio, { target: radio });
        }
        return;
      }
    });

    this.bundleModules.addEventListener('change', (event) => {
      const radio = event.target.closest('.variant-radio, .extra-variant-radio');
      if (radio) {
        this.handleVariantRadioChange(radio, event);
      }
    });
  }

  handleQuantityButtonClick(event) {
    const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
    const moduleEl = button.closest('.bundle-product-module');
    const handle = moduleEl.dataset.moduleHandle;
    const module = this.modules.get(handle);
    if (!module) return;

    const isDecrease = button.hasAttribute('data-quantity-decrease');
    const newQuantity = isDecrease ? Math.max(0, module.quantity - 1) : Math.min(module.maxQuantity, module.quantity + 1);

    this.updateModuleQuantity(handle, newQuantity);
  }

  handleAddToBundleClick(event) {
    const moduleEl = event.target.closest('.bundle-product-module');
    const handle = moduleEl.dataset.moduleHandle;
    if (handle) {
      this.updateModuleQuantity(handle, 1);
    }
  }

  handleRemoveFromBundleClick(event) {
    const moduleEl = event.target.closest('.bundle-product-module');
    const handle = moduleEl.dataset.moduleHandle;
    if (handle) {
      this.updateModuleQuantity(handle, 0);
    }
  }

  handleModuleHeaderClick(event) {
    const moduleEl = event.target.closest('.bundle-product-module');
    const handle = moduleEl.dataset.moduleHandle;
    const module = this.modules.get(handle);
    if (!module) return;

    const hasVariants = (module.variants && module.variants.length > 1) || module.hasExtraVariants;

    if (module.quantity <= 0) {
      this.updateModuleQuantity(handle, 1);
      if (hasVariants) {
        this.openAccordion(handle);
      }
    } else if (hasVariants) {
      this.toggleAccordion(handle);
    }
  }

  handleDropdownToggle(event) {
    const dropdownToggle = event.target.closest('[data-dropdown-toggle]');
    const dropdownSection = dropdownToggle.closest('[data-variant-dropdown]');
    const dropdownContent = dropdownSection.querySelector('[data-dropdown-content]');
    const isCurrentlyOpen = dropdownContent.classList.contains('expanded');

    // Close all dropdowns in this module
    const moduleContent = dropdownSection.closest('.module-content');
    if (moduleContent) {
      const allDropdowns = moduleContent.querySelectorAll('[data-variant-dropdown]');
      allDropdowns.forEach(dropdown => {
        const header = dropdown.querySelector('[data-dropdown-toggle]');
        const content = dropdown.querySelector('[data-dropdown-content]');
        if (header) header.classList.remove('active');
        if (content) content.classList.remove('expanded');
      });
    }

    if (!isCurrentlyOpen) {
      dropdownToggle.classList.add('active');
      dropdownContent.classList.add('expanded');
    }

    // No need for height recalculation - CSS handles it naturally now
  }

  toggleAccordion(moduleHandle) {
    const moduleElement = this.bundleModules.querySelector(`.bundle-product-module[data-module-handle="${moduleHandle}"]`);
    const customizationArea = moduleElement?.querySelector('.module-content');
    if (!customizationArea) return;

    const module = this.modules.get(moduleHandle);

    // If quantity > 1, toggle the first quantity line instead of the main content
    if (module && module.quantity > 1) {
      const quantityLinesContainer = moduleElement.querySelector('.module-quantity-lines');
      const firstLineContent = quantityLinesContainer?.querySelector('.quantity-line-content');

      if (firstLineContent) {
        const isOpen = firstLineContent.classList.contains('expanded');
        if (isOpen) {
          // Close all quantity lines in this module
          quantityLinesContainer.querySelectorAll('.quantity-line-content').forEach(content => {
            content.classList.remove('expanded');
          });
          quantityLinesContainer.querySelectorAll('.quantity-line-arrow').forEach(arrow => {
            arrow.style.transform = 'rotate(0deg)';
          });
          // Clear current open accordion tracking
          if (this.currentOpenAccordion === moduleHandle) {
            this.currentOpenAccordion = null;
          }
        } else {
          // Close any other open accordion first (including quantity lines in other modules)
          if (this.currentOpenAccordion && this.currentOpenAccordion !== moduleHandle) {
            this.closeAccordion(this.currentOpenAccordion);
            this.closeAllQuantityLines(this.currentOpenAccordion);
          }
          // Open first quantity line and track this module as open
          this.toggleQuantityLineAccordion(moduleHandle, 1);
          this.currentOpenAccordion = moduleHandle;
        }
        return;
      }
    }

    const isOpen = customizationArea.classList.contains('expanded');

    if (isOpen) {
      this.closeAccordion(moduleHandle);
    } else {
      // Close any open quantity lines in other modules before opening this one
      if (this.currentOpenAccordion && this.currentOpenAccordion !== moduleHandle) {
        this.closeAllQuantityLines(this.currentOpenAccordion);
      }
      this.openAccordion(moduleHandle);
    }
  }

  /**
   * Close all quantity lines in a specific module
   */
  closeAllQuantityLines(moduleHandle) {
    const moduleElement = this.bundleModules.querySelector(`.bundle-product-module[data-module-handle="${moduleHandle}"]`);
    if (!moduleElement) return;

    const quantityLinesContainer = moduleElement.querySelector('.module-quantity-lines');
    if (!quantityLinesContainer) return;

    quantityLinesContainer.querySelectorAll('.quantity-line-content').forEach(content => {
      content.classList.remove('expanded');
    });
    quantityLinesContainer.querySelectorAll('.quantity-line-arrow').forEach(arrow => {
      arrow.style.transform = 'rotate(0deg)';
    });
  }

  openAccordion(moduleHandle, options = { openFirstDropdown: true, openLastQuantityLine: false }) {
    if (this.currentOpenAccordion && this.currentOpenAccordion !== moduleHandle) {
      this.closeAccordion(this.currentOpenAccordion);
    }

    const moduleElement = this.bundleModules.querySelector(`.bundle-product-module[data-module-handle="${moduleHandle}"]`);
    const customizationArea = moduleElement?.querySelector('.module-content');
    if (!customizationArea) return;

    moduleElement.classList.add('module-active');
    customizationArea.classList.add('expanded');
    this.currentOpenAccordion = moduleHandle;

    const module = this.modules.get(moduleHandle);
    if (module) {
      this.syncAccordionWithCurrentVariant(module);

      // Update quantity lines when accordion opens
      this.updateModuleQuantityLines(moduleHandle);
    }

    // Auto-open first dropdown unless disabled
    if (options.openFirstDropdown) {
      // Use requestAnimationFrame to ensure the class addition happens in the next frame
      // if we want to ensure the parent is expanded first, but with CSS Grid it handles nested grids well.
      // We don't need a delay, just open it.
      const firstDropdown = customizationArea.querySelector('[data-variant-dropdown]');
      if (firstDropdown) {
        const header = firstDropdown.querySelector('[data-dropdown-toggle]');
        const content = firstDropdown.querySelector('[data-dropdown-content]');
        if (header && content) {
          header.classList.add('active');
          content.classList.add('expanded');
        }
      }
    }
  }

  closeAccordion(moduleHandle) {
    const moduleElement = this.bundleModules.querySelector(`.bundle-product-module[data-module-handle="${moduleHandle}"]`);
    const customizationArea = moduleElement?.querySelector('.module-content');
    if (!customizationArea) return;

    moduleElement.classList.remove('module-active');
    customizationArea.classList.remove('expanded');

    // Close all dropdowns
    const allDropdowns = customizationArea.querySelectorAll('[data-variant-dropdown]');
    allDropdowns.forEach(dropdown => {
      const header = dropdown.querySelector('[data-dropdown-toggle]');
      const content = dropdown.querySelector('[data-dropdown-content]');
      if (header) header.classList.remove('active');
      if (content) content.classList.remove('expanded');
    });

    if (this.currentOpenAccordion === moduleHandle) {
      this.currentOpenAccordion = null;
    }
  }

  updateModuleQuantity(handle, quantity) {
    const module = this.modules.get(handle);
    if (!module) return;

    const oldQuantity = module.quantity;
    module.quantity = quantity;

    if (module.quantityInput) module.quantityInput.value = quantity;
    if (module.quantityDisplay) module.quantityDisplay.textContent = quantity;

    this.toggleQuantityDisplay(module);

    // Handle multiple quantity customization
    if (oldQuantity > 0 && quantity > oldQuantity) {
      this.handleMultipleQuantityCustomization(handle, oldQuantity, quantity);
    }

    // If quantity decreased, keep only the customizations for the new quantity
    if (quantity < oldQuantity && module.customizations && module.customizations.length > quantity) {
      module.customizations = module.customizations.slice(0, Math.max(1, quantity));
    }

    // Always update quantity lines (both when increasing and decreasing)
    this.updateModuleQuantityLines(handle);

    if (quantity === 0 && this.currentOpenAccordion === handle) {
      this.closeAccordion(handle);
    }

    this.updateModulePriceDisplay(module);
    this.updateMainProductPrice();
    this.updateAddToCartButtonState();
    this.saveModuleState();
  }

  handleMultipleQuantityCustomization(moduleHandle, oldQuantity, newQuantity) {
    const module = this.modules.get(moduleHandle);
    if (!module) return;

    // Initialize customizations array
    if (!module.customizations) {
      module.customizations = [];
    }

    // Ensure we have customizations for all quantities
    while (module.customizations.length < newQuantity) {
      // For the first customization, use current variant and extra variant selections
      if (module.customizations.length === 0) {
        module.customizations.push({
          variantId: module.currentVariant?.id || module.productId,
          extraVariants: JSON.parse(JSON.stringify(this.extraVariantsSelections.get(moduleHandle) || []))
        });
      } else {
        // For additional customizations, copy from the LAST one for intuitive UX
        const lastCustomization = module.customizations[module.customizations.length - 1];
        module.customizations.push(JSON.parse(JSON.stringify(lastCustomization)));
      }
    }

    this.saveModuleState();
    this.openAccordion(moduleHandle, { openFirstDropdown: false });

    // Auto-open the new quantity line (or first line if going from 1 to 2)
    if (newQuantity > 1) {
      const targetLine = newQuantity > oldQuantity ? newQuantity : 1;
      this.toggleQuantityLineAccordion(moduleHandle, targetLine);
    }
  }

  updateModuleQuantityLines(handle) {
    const module = this.modules.get(handle);
    if (!module || !module.element) return;

    let quantityLinesContainer = module.element.querySelector('.module-quantity-lines');
    const moduleContent = module.element.querySelector('.module-content');
    const isMainAccordionOpen = moduleContent && moduleContent.classList.contains('expanded');

    // Show quantity lines if quantity > 1 and either accordion is open OR module has variants
    const hasVariants = (module.variants && module.variants.length > 1) || module.hasExtraVariants;
    if (module.quantity > 1 && (isMainAccordionOpen || hasVariants)) {
      // Create container if doesn't exist
      if (!quantityLinesContainer) {
        quantityLinesContainer = document.createElement('div');
        quantityLinesContainer.className = 'module-quantity-lines';
        moduleContent.insertAdjacentElement('afterend', quantityLinesContainer);
      }

      quantityLinesContainer.innerHTML = '';
      const moduleName = module.element.querySelector('.module-product-title')?.textContent || 'Ürün';

      // Create lines starting from 1 (including the first one)
      for (let i = 1; i <= module.quantity; i++) {
        const lineItem = this.createQuantityLineItem(handle, i, moduleName, module);
        quantityLinesContainer.appendChild(lineItem);
      }

      // Hide the main accordion content since all items are now in quantity lines
      if (moduleContent) {
        moduleContent.classList.add('hidden-for-quantity-lines');
      }
    } else if (quantityLinesContainer) {
      quantityLinesContainer.remove();
      // Show the main accordion content if quantity lines are removed
      if (moduleContent) {
        moduleContent.classList.remove('hidden-for-quantity-lines');
      }
    }
  }

  createQuantityLineItem(moduleHandle, quantityIndex, moduleName, module) {
    const lineItem = document.createElement('div');
    lineItem.className = 'quantity-line-item';
    lineItem.dataset.quantityIndex = quantityIndex;

    if (quantityIndex === module.quantity) {
      lineItem.classList.add('last-item');
    }

    // Create header with click handler
    const lineHeader = document.createElement('div');
    lineHeader.className = 'quantity-line-header';
    lineHeader.innerHTML = `
      <span>${moduleName} - ${quantityIndex}</span>
      <div class="quantity-line-arrow">
        <svg viewBox="0 0 12 8" style="width: 12px; height: 8px;">
          <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" fill="none"/>
        </svg>
      </div>
    `;

    lineHeader.onclick = () => this.toggleQuantityLineAccordion(moduleHandle, quantityIndex);

    // Clone content only if module has variants or extra variants
    const hasVariants = (module.variants && module.variants.length > 1) || module.hasExtraVariants;
    if (hasVariants) {
      const originalContent = module.element.querySelector('.module-content');
      const clonedContent = originalContent.cloneNode(true);
      clonedContent.className = 'quantity-line-content';
      clonedContent.classList.remove('expanded');

      // CRITICAL: Remove inline styles from the clone, especially `display: none`
      clonedContent.removeAttribute('style');

      // Make IDs unique and add event handling
      this.setupQuantityLineContent(clonedContent, moduleHandle, quantityIndex);

      lineItem.appendChild(lineHeader);
      lineItem.appendChild(clonedContent);
    } else {
      lineItem.appendChild(lineHeader);
    }

    return lineItem;
  }

  setupQuantityLineContent(clonedContent, moduleHandle, quantityIndex) {
    // Update radio IDs and names to be unique
    const radios = clonedContent.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      const oldId = radio.id;
      radio.id = `${oldId}-qty-${quantityIndex}`;
      radio.name = `${radio.name}-qty-${quantityIndex}`;

      const label = clonedContent.querySelector(`label[for="${oldId}"]`);
      if (label) label.setAttribute('for', radio.id);
    });

    // Handle clicks with event delegation
    clonedContent.addEventListener('click', (event) => {
      const dropdownToggle = event.target.closest('[data-dropdown-toggle]');
      if (dropdownToggle) {
        event.preventDefault();
        this.handleQuantityLineDropdownToggle(event, clonedContent);
        return;
      }

      const moduleOption = event.target.closest('.module-option');
      if (moduleOption && !event.target.matches('input[type="radio"]')) {
        const radio = moduleOption.querySelector('.variant-radio, .extra-variant-radio');
        if (radio) {
          radio.checked = true;
          this.handleQuantityLineVariantSelection(radio, moduleHandle, quantityIndex);
        }
      }

      const listOption = event.target.closest('.module-list-option');
      if (listOption) {
        const radio = listOption.querySelector('.variant-radio');
        if (radio) {
          radio.checked = true;
          this.handleQuantityLineVariantSelection(radio, moduleHandle, quantityIndex);
        }
      }
    });

    // Handle radio changes
    clonedContent.addEventListener('change', (event) => {
      const radio = event.target;
      if (radio.type === 'radio' && (radio.classList.contains('variant-radio') || radio.classList.contains('extra-variant-radio'))) {
        // Handle extra variant exclusivity
        if (radio.classList.contains('extra-variant-radio')) {
          const radioName = radio.getAttribute('name');
          const allRadiosInGroup = clonedContent.querySelectorAll(`input[name="${radioName}"]`);
          allRadiosInGroup.forEach(r => {
            if (r !== radio) r.checked = false;
          });
        }

        this.handleQuantityLineVariantSelection(radio, moduleHandle, quantityIndex);
      }
    });

    // Sync with saved customization
    this.syncQuantityLineWithCustomization(moduleHandle, quantityIndex, clonedContent);
  }

  handleQuantityLineDropdownToggle(event, clonedContent) {
    event.preventDefault();
    event.stopPropagation();

    const dropdownToggle = event.target.closest('[data-dropdown-toggle]');
    const dropdownSection = dropdownToggle.closest('[data-variant-dropdown]');
    const dropdownContent = dropdownSection.querySelector('[data-dropdown-content]');
    const isCurrentlyOpen = dropdownContent.classList.contains('expanded');

    // Close all dropdowns in this content first
    const allDropdowns = clonedContent.querySelectorAll('[data-variant-dropdown]');
    allDropdowns.forEach(dropdown => {
      const header = dropdown.querySelector('[data-dropdown-toggle]');
      const content = dropdown.querySelector('[data-dropdown-content]');
      if (header) header.classList.remove('active');
      if (content) content.classList.remove('expanded');
    });

    // Open clicked dropdown if it was closed
    if (!isCurrentlyOpen) {
      dropdownToggle.classList.add('active');
      dropdownContent.classList.add('expanded');

      // Special handling for extra variant dropdowns
      const isExtraVariant = dropdownToggle.dataset.optionName === 'extra-variant';
      // CSS handles height, no recalculation needed
    }

    // No need for height recalculation - CSS handles it naturally now
  }

  /**
   * Recalculates and updates the height of a quantity line content container
   * NOTE: This function is now deprecated as CSS handles height naturally
   */
  recalculateQuantityLineHeight(clonedContent) {
    // Deprecated - CSS now handles height automatically
    return;
  }

  /**
   * Handle dropdown progression for quantity lines (similar to BaseCustomizer)
   */
  handleQuantityLineDropdownProgression(radio) {
    const dropdownSection = radio.closest('[data-variant-dropdown]');
    if (!dropdownSection) return;

    const dropdownHeader = dropdownSection.querySelector('[data-dropdown-toggle]');
    const dropdownContent = dropdownSection.querySelector('[data-dropdown-content]');

    if (dropdownHeader && dropdownContent) {
      if (dropdownHeader && dropdownContent) {
        dropdownHeader.classList.remove('active');
        dropdownContent.classList.remove('expanded');

        // Find next dropdown in the same quantity line
        const quantityLineContent = radio.closest('.quantity-line-content');
        if (quantityLineContent) {
          const allDropdowns = quantityLineContent.querySelectorAll('[data-variant-dropdown]');
          const currentIndex = Array.from(allDropdowns).indexOf(dropdownSection);

          if (currentIndex < allDropdowns.length - 1) {
            const nextDropdown = allDropdowns[currentIndex + 1];
            const nextHeader = nextDropdown.querySelector('[data-dropdown-toggle]');
            const nextContent = nextDropdown.querySelector('[data-dropdown-content]');

            if (nextHeader && nextContent) {
              nextHeader.classList.add('active');
              nextContent.classList.add('expanded');
            }
          }
        }

        // No height recalculation needed - CSS handles it
      }
    }
  }

  handleQuantityLineVariantSelection(radio, moduleHandle, quantityIndex) {
    const module = this.modules.get(moduleHandle);
    if (!module) return;

    // Use BaseCustomizer's variant handling pattern for consistency
    requestAnimationFrame(() => {
      this.updateVisualSelection(radio);
      this.updateBundleDropdownHeader(radio, module);
    });

    // Handle dropdown progression with BaseCustomizer pattern
    this.handleQuantityLineDropdownProgression(radio);

    // Update customization for this quantity
    this.updateQuantityCustomization(radio, moduleHandle, quantityIndex);

    // Update prices
    this.updateModulePriceDisplay(module);
    this.updateMainProductPrice();
  }

  updateQuantityCustomization(radio, moduleHandle, quantityIndex) {
    const module = this.modules.get(moduleHandle);
    if (!module) return;

    if (!module.customizations) module.customizations = [];

    // Ensure customizations array has enough slots
    while (module.customizations.length < quantityIndex) {
      module.customizations.push({
        variantId: module.currentVariant?.id || module.productId,
        extraVariants: []
      });
    }

    // Get customization for this index
    const customizationIndex = quantityIndex - 1;
    if (!module.customizations[customizationIndex]) {
      module.customizations[customizationIndex] = { variantId: null, extraVariants: [] };
    }

    if (radio.classList.contains('variant-radio')) {
      // Find matching variant from selected options in this quantity line
      const lineItem = radio.closest('[data-quantity-index]');
      const selectedRadios = lineItem.querySelectorAll('.variant-radio:checked');
      const selectedOptions = Array.from(selectedRadios).map(r => r.dataset.optionValue);

      const matchingVariant = module.variants.find(variant => {
        if (!variant.title) return false;
        const variantOptions = variant.title.split(' / ').map(opt => opt.trim());
        return selectedOptions.every(option => variantOptions.includes(option));
      });

      if (matchingVariant) {
        module.customizations[customizationIndex].variantId = matchingVariant.id;
      }
    }

    if (radio.classList.contains('extra-variant-radio')) {
      const parentContext = radio.closest('.quantity-line-content, .module-content');
      const checkedExtraRadios = parentContext.querySelectorAll('.extra-variant-radio:checked');

      const extraVariants = Array.from(checkedExtraRadios).map(r => ({
        id: r.dataset.extraVariantId,
        label: r.dataset.label,
        price: parseFloat(r.dataset.price || 0),
        image: r.dataset.variantImage || null
      }));

      module.customizations[customizationIndex].extraVariants = extraVariants;
    }

    this.saveModuleState();
  }

  toggleQuantityLineAccordion(moduleHandle, quantityIndex) {
    const module = this.modules.get(moduleHandle);
    if (!module) return;

    const quantityLinesContainer = module.element.querySelector('.module-quantity-lines');
    if (!quantityLinesContainer) return;

    const lineItem = quantityLinesContainer.querySelector(`[data-quantity-index="${quantityIndex}"]`);
    const lineContent = lineItem?.querySelector('.quantity-line-content');
    const arrow = lineItem?.querySelector('.quantity-line-arrow');

    if (!lineContent) return;

    const isExpanded = lineContent.classList.contains('expanded');

    // Close all other quantity lines in this module
    quantityLinesContainer.querySelectorAll('.quantity-line-content').forEach(content => {
      if (content !== lineContent) {
        content.classList.remove('expanded');
      }
    });

    quantityLinesContainer.querySelectorAll('.quantity-line-arrow').forEach(arr => {
      if (arr !== arrow) {
        arr.style.transform = 'rotate(0deg)';
      }
    });

    // Toggle current line
    if (!isExpanded) {
      // Close any other open accordion/quantity lines in other modules before opening this one
      if (this.currentOpenAccordion && this.currentOpenAccordion !== moduleHandle) {
        this.closeAccordion(this.currentOpenAccordion);
        this.closeAllQuantityLines(this.currentOpenAccordion);
      }

      lineContent.classList.add('expanded');
      if (arrow) arrow.style.transform = 'rotate(180deg)';

      // Track this module as open
      this.currentOpenAccordion = moduleHandle;

      // Open first dropdown immediately for smooth transition
      const firstDropdown = lineContent.querySelector('[data-variant-dropdown]');
      if (firstDropdown) {
        const header = firstDropdown.querySelector('[data-dropdown-toggle]');
        const content = firstDropdown.querySelector('[data-dropdown-content]');
        if (header && content) {
          header.classList.add('active');
          content.classList.add('expanded');
        }
      }

      // No manual height calculation needed - CSS handles it naturally
    } else {
      lineContent.classList.remove('expanded');
      if (arrow) arrow.style.transform = 'rotate(0deg)';

      // Clear current open accordion tracking if all lines are closed
      const hasAnyExpanded = quantityLinesContainer.querySelector('.quantity-line-content.expanded');
      if (!hasAnyExpanded && this.currentOpenAccordion === moduleHandle) {
        this.currentOpenAccordion = null;
      }
    }
  }

  syncQuantityLineWithCustomization(moduleHandle, quantityIndex, clonedContent) {
    const module = this.modules.get(moduleHandle);
    const customization = module?.customizations?.[quantityIndex - 1];

    // For the first quantity line, sync with current variant if no customization exists
    if (!customization && quantityIndex === 1) {
      // Sync with current variant selection from main accordion
      if (module?.currentVariant?.title) {
        const variantOptions = module.currentVariant.title.split(' / ').map(opt => opt.trim());
        variantOptions.forEach(optionValue => {
          const radio = clonedContent.querySelector(`.variant-radio[data-option-value="${optionValue}"]`);
          if (radio) {
            radio.checked = true;
            this.updateVisualSelection(radio);
            this.updateBundleDropdownHeader(radio, module);
          }
        });
      }

      // Sync with current extra variant selection
      const currentExtraVariants = this.extraVariantsSelections.get(moduleHandle);
      if (currentExtraVariants?.length > 0) {
        const extraVariant = currentExtraVariants[0];
        const radio = clonedContent.querySelector(`.extra-variant-radio[data-extra-variant-id="${extraVariant.id}"]`);
        if (radio) {
          radio.checked = true;
          this.updateVisualSelection(radio);
          this.updateBundleDropdownHeader(radio, module);
        }
      }
      return;
    }

    if (!customization) return;

    // Restore variant selection
    if (customization.variantId) {
      const variant = module.variants.find(v => v.id === customization.variantId);
      if (variant?.title) {
        const variantOptions = variant.title.split(' / ').map(opt => opt.trim());
        variantOptions.forEach(optionValue => {
          const radio = clonedContent.querySelector(`.variant-radio[data-option-value="${optionValue}"]`);
          if (radio) {
            radio.checked = true;
            this.updateVisualSelection(radio);
            this.updateBundleDropdownHeader(radio, module);
          }
        });
      }
    }

    // Restore extra variant selection
    if (customization.extraVariants?.length > 0) {
      const extraVariant = customization.extraVariants[0];
      const radio = clonedContent.querySelector(`.extra-variant-radio[data-extra-variant-id="${extraVariant.id}"]`);
      if (radio) {
        radio.checked = true;
        this.updateVisualSelection(radio);
        this.updateBundleDropdownHeader(radio, module);
      }
    }
  }

  handleVariantRadioChange(radio, event) {
    // If this radio is inside a quantity line, do nothing.
    // The quantity line has its own dedicated handler.
    if (radio.closest('.quantity-line-content')) {
      return;
    }

    const moduleElement = radio.closest('.bundle-product-module');
    if (!moduleElement) return;

    const moduleHandle = moduleElement.dataset.moduleHandle;
    const module = this.modules.get(moduleHandle);
    if (!module) return;

    this.updateVisualSelection(radio);
    this.updateBundleDropdownHeader(radio, module);
    this.handleBundleDropdownProgression(radio);

    if (radio.classList.contains('variant-radio')) {
      this.updateSelectedVariant(moduleHandle, moduleElement);
    }

    if (radio.classList.contains('extra-variant-radio')) {
      this.updateExtraVariantSelection(moduleHandle, radio);
    }

    this.updateMainProductPrice();
  }

  /**
   * Handle dropdown progression specific to bundle modules
   */
  handleBundleDropdownProgression(radio) {
    const dropdownSection = radio.closest('[data-variant-dropdown]');
    if (!dropdownSection) return;

    const dropdownHeader = dropdownSection.querySelector('[data-dropdown-toggle]');
    const dropdownContent = dropdownSection.querySelector('[data-dropdown-content]');

    if (dropdownHeader && dropdownContent) {
      if (dropdownHeader && dropdownContent) {
        dropdownHeader.classList.remove('active');
        dropdownContent.classList.remove('expanded');

        // Find next dropdown in the same module
        const moduleContent = dropdownSection.closest('.module-content');
        if (moduleContent) {
          const allDropdowns = moduleContent.querySelectorAll('[data-variant-dropdown]');
          const currentIndex = Array.from(allDropdowns).indexOf(dropdownSection);

          if (currentIndex < allDropdowns.length - 1) {
            const nextDropdown = allDropdowns[currentIndex + 1];
            const nextHeader = nextDropdown.querySelector('[data-dropdown-toggle]');
            const nextContent = nextDropdown.querySelector('[data-dropdown-content]');

            if (nextHeader && nextContent) {
              nextHeader.classList.add('active');
              nextContent.classList.add('expanded');
            }
          }
        }
      }
    }
  }

  updateBundleDropdownHeader(radio, module) {
    const dropdownSection = radio.closest('[data-variant-dropdown]');
    const selectedValueSpan = dropdownSection?.querySelector('[data-selected-value]');
    if (!selectedValueSpan) return;

    if (radio.classList.contains('variant-radio')) {
      selectedValueSpan.textContent = radio.dataset.optionValue || 'Select';
    } else if (radio.classList.contains('extra-variant-radio')) {
      selectedValueSpan.textContent = radio.dataset.label || 'Select';
    }

    const priceDiffSpan = dropdownSection.querySelector('[data-price-tag]');
    if (priceDiffSpan && radio.classList.contains('variant-radio')) {
      this.updatePriceDifference(radio, priceDiffSpan, module);
    }
  }

  updateSelectedVariant(moduleHandle, moduleElement) {
    const module = this.modules.get(moduleHandle);
    if (!module) return;

    const mainContentArea = moduleElement.querySelector('.module-content');
    const selectedRadios = mainContentArea?.querySelectorAll('.variant-radio:checked');
    if (!selectedRadios?.length) return;

    const selectedOptions = Array.from(selectedRadios).map(radio => radio.dataset.optionValue);
    const matchingVariant = module.variants.find(variant => {
      if (!variant.title) return false;
      const variantOptions = variant.title.split(' / ').map(opt => opt.trim());
      return selectedOptions.every(option => variantOptions.includes(option));
    });

    if (matchingVariant) {
      module.currentVariant = matchingVariant;
      module.productId = matchingVariant.id;

      let basePrice = matchingVariant.price;
      let comparePrice = matchingVariant.compare_at_price || basePrice;

      const extraVariants = this.extraVariantsSelections.get(moduleHandle) || [];
      extraVariants.forEach(ev => {
        const extraPrice = (ev.price * 100);
        basePrice += extraPrice;
        comparePrice += extraPrice;
      });

      module.productPrice = basePrice;
      module.productComparePrice = comparePrice;

      if (module.quantityInput) {
        module.quantityInput.dataset.productId = matchingVariant.id;
        module.quantityInput.dataset.productPrice = basePrice;
      }

      if (module.customizations && module.customizations.length > 0) {
        module.customizations[0].variantId = matchingVariant.id;
      }

      // Update module price display in the header
      this.updateModulePriceDisplay(module);

      module.hasCustomSelection = true;
      this.saveModuleState();
    }
  }

  updateModulePriceDisplay(module) {
    if (!module.element) return;

    const priceContainer = module.element.querySelector('.module-product-price');
    if (!priceContainer) return;

    let sellingPrice, comparePrice;

    if (module.quantity > 0) {
      const result = this.calculateModulePrice(module, { useCustomizations: true });
      sellingPrice = result.sellingPrice;
      comparePrice = result.comparePrice;
    } else {
      sellingPrice = module.productPrice;
      comparePrice = module.productComparePrice;
    }

    const showSale = comparePrice && comparePrice > sellingPrice;

    let priceHTML;

    if (showSale) {
      priceHTML = `
        <span class="module-base-price">${this.formatMoney(sellingPrice)}</span>
        <span class="module-compare-price" style="text-decoration: line-through; opacity: 0.7; margin-left: 6px;">${this.formatMoney(comparePrice)}</span>
      `;
    } else {
      priceHTML = `<span class="module-base-price">${this.formatMoney(sellingPrice)}</span>`;
    }

    priceContainer.innerHTML = priceHTML;
  }

  updateExtraVariantSelection(moduleHandle, radio) {
    const extraVariantSelections = [];

    if (radio.checked && radio.dataset.extraVariantId) {
      extraVariantSelections.push({
        id: radio.dataset.extraVariantId,
        label: radio.dataset.label,
        price: parseFloat(radio.dataset.price || 0),
        image: radio.dataset.variantImage || null
      });
    }

    this.extraVariantsSelections.set(moduleHandle, extraVariantSelections);

    const module = this.modules.get(moduleHandle);
    if (module) {
      if (module.customizations && module.customizations.length > 0) {
        module.customizations[0].extraVariants = extraVariantSelections;
      }

      if (module.currentVariant) {
        let basePrice = module.currentVariant.price;
        extraVariantSelections.forEach(ev => {
          basePrice += (ev.price * 100);
        });
        module.productPrice = basePrice;

        // Update module price display in the header
        this.updateModulePriceDisplay(module);
      }
    }

    this.saveModuleState();
  }

  updatePriceDifference(radio, priceDiffElement, module) {
    if (!radio.dataset.price || !priceDiffElement || !module) return;

    const selectedPrice = parseInt(radio.dataset.price, 10);
    if (isNaN(selectedPrice)) return;

    const baseVariant = module.variants && module.variants.length > 0 ? module.variants[0] : null;
    if (!baseVariant) return;

    const priceDiff = selectedPrice - baseVariant.price;
    priceDiffElement.style.display = 'inline';

    if (priceDiff !== 0) {
      priceDiffElement.textContent = `${priceDiff > 0 ? '+' : ''}${this.formatMoney(priceDiff)}`;
      priceDiffElement.classList.add('has-price');
    } else {
      priceDiffElement.textContent = `+${this.formatMoney(0)}`;
      priceDiffElement.classList.remove('has-price');
    }
  }

  onFormSubmit(event) {
    this.handleAddBundleToCart();
    return false;
  }

  onAddToCart(event) {
    this.handleAddBundleToCart();
    return false;
  }

  async handleAddBundleToCart() {
    if (this._isAddingBundleToCart) return;
    this._isAddingBundleToCart = true;

    try {
      const selectedModules = Array.from(this.modules.values()).filter(module => module.quantity > 0);

      if (selectedModules.length === 0) {
        this.showMessage('Sepete eklemek için en az bir modül seçin.', 'error');
        return;
      }

      this.showLoadingState();
      this.saveModuleState();

      const cartItems = this.prepareCartItems(this.modules, this.extraVariantsSelections);

      if (cartItems.length === 0) {
        throw new Error('Sepete eklenecek geçerli ürün bulunamadı');
      }

      await this.addToCart(cartItems);
      this.showMessage('Takım sepete eklendi', 'success');

    } catch (error) {
      let errorMessage = 'Takım sepete eklenirken hata oluştu.';
      if (error.message && error.message.toLowerCase().includes('inventory')) {
        errorMessage = 'Modüllerden bazılarının stoğu yetersiz.';
      } else if (error.message) {
        errorMessage = error.message;
      }
      this.showMessage(errorMessage, 'error');
    } finally {
      this._isAddingBundleToCart = false;
      this.hideLoadingState();
    }
  }

  updateMainProductPrice() {
    if (!this.priceContainer) return;

    if (this.originalPriceContainerHTML === null) {
      this.originalPriceContainerHTML = this.priceContainer.innerHTML;
    }

    const priceResult = this.calculateBundlePrice(this.modules, {
      includeComparePrice: true,
      useCustomizations: true
    });

    const hasSelectedModules = priceResult.hasSelectedModules;
    const currentBundleSellingPrice = priceResult.sellingPrice;
    const currentBundleCompareAtPrice = priceResult.comparePrice;

    if (hasSelectedModules) {
      // Only update if this is the actual price container, not a nested one
      if (this.priceContainer.hasAttribute('ref') && this.priceContainer.getAttribute('ref') === 'priceContainer') {
        // We're targeting the inner price container directly
        this.priceContainer.innerHTML = this.renderPriceDisplay(currentBundleSellingPrice, currentBundleCompareAtPrice);
      } else {
        // We're targeting the outer container
        this.priceContainer.innerHTML = this.renderPriceDisplay(currentBundleSellingPrice, currentBundleCompareAtPrice);
      }

      // Update sticky price container
      if (!this.stickyPriceContainer || !this.stickyPriceContainer.isConnected) {
        this.stickyPriceContainer = document.querySelector('.sticky-add-to-cart__price') ||
          document.querySelector('[data-testid="sticky-price-display"]');
      }

      if (this.stickyPriceContainer) {
        this.stickyPriceContainer.innerHTML = this.renderPriceDisplay(currentBundleSellingPrice, currentBundleCompareAtPrice);
      }
    } else {
      this.priceContainer.innerHTML = this.originalPriceContainerHTML;

      if (this.stickyPriceContainer && this.originalStickyPriceContainerHTML) {
        this.stickyPriceContainer.innerHTML = this.originalStickyPriceContainerHTML;
      }
    }
  }

  updateAddToCartButtonState() {
    const hasSelectedModules = Array.from(this.modules.values()).some(module => module.quantity > 0);

    if (this.addToCartButton) {
      if (!this.addToCartButton.dataset.originalHtml) {
        this.addToCartButton.dataset.originalHtml = this.addToCartButton.innerHTML;
      }

      if (hasSelectedModules) {
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartButton.setAttribute('aria-disabled', 'false');
        this.addToCartButton.innerHTML = this.addToCartButton.dataset.originalHtml;
      } else {
        this.addToCartButton.setAttribute('disabled', 'disabled');
        this.addToCartButton.setAttribute('aria-disabled', 'true');

        const buttonTextSpan = this.addToCartButton.querySelector('span:not(.loading-overlay__spinner)');
        if (buttonTextSpan) {
          buttonTextSpan.textContent = 'Lütfen Modül Seçin';
        }
      }
    }
  }

  toggleQuantityDisplay(module) {
    if (!module || !module.ui) return;

    const { quantityWrapper, addToBundleBtn, editBtn, removeBtn } = module.ui;

    if (module.quantity > 0) {
      module.element.classList.remove('is-inactive');
      if (quantityWrapper) quantityWrapper.style.display = 'flex';
      if (addToBundleBtn) addToBundleBtn.style.display = 'none';
      if (removeBtn) removeBtn.style.display = 'block';

      const hasVariants = (module.variants && module.variants.length > 1) || module.hasExtraVariants;
      if (editBtn) editBtn.style.display = hasVariants ? 'block' : 'none';
    } else {
      module.element.classList.add('is-inactive');
      if (quantityWrapper) quantityWrapper.style.display = 'none';
      if (addToBundleBtn) addToBundleBtn.style.display = 'block';
      if (editBtn) editBtn.style.display = 'none';
      if (removeBtn) removeBtn.style.display = 'none';
    }
  }

  initializeModules() {
    const moduleElements = this.bundleModules.querySelectorAll('.bundle-product-module');

    moduleElements.forEach(moduleEl => {
      const handle = moduleEl.dataset.moduleHandle;
      const quantityInput = moduleEl.querySelector('[data-quantity-input]');
      const quantityDisplay = moduleEl.querySelector('[data-quantity-display]');

      if (!quantityInput) return;

      const currentQuantity = parseInt(quantityInput.value) || 0;

      let variants = [];
      try {
        const variantsData = quantityInput.dataset.variants;
        if (variantsData) {
          variants = JSON.parse(variantsData);
        }
      } catch (e) {
        console.warn('Error parsing variants data for module:', handle);
      }

      const defaultVariantId = moduleEl.dataset.defaultVariantId ? parseInt(moduleEl.dataset.defaultVariantId, 10) : null;
      let initialVariant = variants.length > 0 ? variants[0] : null;

      if (defaultVariantId && variants.length > 0) {
        const foundVariant = variants.find(v => v.id === defaultVariantId);
        if (foundVariant) {
          initialVariant = foundVariant;
        }
      }

      // Extract option names from dropdown headers for cart properties
      const optionNames = [];
      const dropdownToggles = moduleEl.querySelectorAll('[data-dropdown-toggle][data-option-name]');
      dropdownToggles.forEach(toggle => {
        const optionName = toggle.dataset.optionName;
        if (optionName && optionName !== 'extra-variant') {
          optionNames.push(optionName);
        }
      });

      const module = {
        element: moduleEl,
        handle: handle,
        quantity: currentQuantity,
        quantityInput: quantityInput,
        quantityDisplay: quantityDisplay,
        productId: initialVariant ? initialVariant.id : quantityInput.dataset.productId,
        productPrice: initialVariant ? initialVariant.price : parseInt(quantityInput.dataset.productPrice) || 0,
        productComparePrice: initialVariant ? initialVariant.compare_at_price : parseInt(quantityInput.dataset.productComparePrice) || 0,
        maxQuantity: moduleEl.dataset.maxQuantity || parseInt(quantityInput.max) || 10,
        variants: variants,
        currentVariant: initialVariant,
        hasCustomSelection: false,
        hasExtraVariants: moduleEl.dataset.hasExtraVariants === 'true',
        customizations: [],
        optionNames: optionNames, // Store option names for cart properties
        // Cache UI elements for performance
        ui: {
          quantityWrapper: moduleEl.querySelector('[data-quantity-wrapper]'),
          addToBundleBtn: moduleEl.querySelector('[data-add-to-bundle]'),
          editBtn: moduleEl.querySelector('[data-module-design]'),
          removeBtn: moduleEl.querySelector('[data-remove-from-bundle]')
        }
      };

      // Initialize customizations array based on current quantity
      if (currentQuantity > 0) {
        for (let i = 0; i < currentQuantity; i++) {
          module.customizations.push({
            variantId: initialVariant?.id || module.productId,
            extraVariants: []
          });
        }
      }

      this.modules.set(handle, module);

      if (quantityDisplay) {
        quantityDisplay.textContent = currentQuantity;
      }

      this.toggleQuantityDisplay(module);

      // Update module price display
      this.updateModulePriceDisplay(module);

      if (initialVariant && currentQuantity > 0) {
        this.syncAccordionWithCurrentVariant(module);

        // Update module price display after sync
        this.updateModulePriceDisplay(module);
      }
    });
  }

  syncAccordionWithCurrentVariant(module) {
    const moduleElement = module.element;
    if (!moduleElement || !module.currentVariant?.title) return;

    const customizationArea = moduleElement.querySelector('.module-content');
    if (!customizationArea) return;

    const variantOptions = module.currentVariant.title.split(' / ').map(opt => opt.trim());

    variantOptions.forEach(optionValue => {
      const matchingRadio = customizationArea.querySelector(`.variant-radio[data-option-value="${optionValue}"]`);
      if (matchingRadio) {
        matchingRadio.checked = true;
        this.updateVisualSelection(matchingRadio);

        const dropdownSection = matchingRadio.closest('[data-variant-dropdown]');
        if (dropdownSection) {
          const selectedValueSpan = dropdownSection.querySelector('[data-selected-value]');
          const priceDiffSpan = dropdownSection.querySelector('[data-price-tag]');

          if (selectedValueSpan) {
            selectedValueSpan.textContent = optionValue;
          }

          if (priceDiffSpan) {
            this.updatePriceDifference(matchingRadio, priceDiffSpan, module);
          }
        }

        // Mark option as visually selected
        this.updateVisualSelection(matchingRadio);
      }
    });

    // Handle extra variant selection - restore from saved state if available
    const savedExtraVariants = this.extraVariantsSelections.get(module.handle);
    if (savedExtraVariants && savedExtraVariants.length > 0) {
      const savedExtraVariant = savedExtraVariants[0];
      const matchingExtraRadio = customizationArea.querySelector(`.extra-variant-radio[data-extra-variant-id="${savedExtraVariant.id}"]`);
      if (matchingExtraRadio) {
        matchingExtraRadio.checked = true;
        this.updateVisualSelection(matchingExtraRadio);
        const dropdownSection = matchingExtraRadio.closest('[data-variant-dropdown]');
        if (dropdownSection) {
          const selectedValueSpan = dropdownSection.querySelector('[data-selected-value]');
          if (selectedValueSpan) {
            selectedValueSpan.textContent = savedExtraVariant.label || 'Seçiniz';
          }
        }
      }
    } else {
      // Fallback to first extra variant if no saved state
      const firstExtraRadio = customizationArea.querySelector('.extra-variant-radio');
      if (firstExtraRadio) {
        firstExtraRadio.checked = true;
        this.updateVisualSelection(firstExtraRadio);
        const dropdownSection = firstExtraRadio.closest('[data-variant-dropdown]');
        if (dropdownSection) {
          const selectedValueSpan = dropdownSection.querySelector('[data-selected-value]');
          if (selectedValueSpan) {
            selectedValueSpan.textContent = firstExtraRadio.dataset.label || 'Seçiniz';
          }
        }
      }
    }
  }

  loadModuleState() {
    try {
      const savedState = this.getStorageItem(this.sessionStorageKey);
      if (!savedState) return;

      const moduleState = JSON.parse(savedState);

      Object.entries(moduleState).forEach(([handle, state]) => {
        const module = this.modules.get(handle);
        if (!module) return;

        // Restore quantity
        if (typeof state.quantity === 'number') {
          module.quantity = state.quantity;
          if (module.quantityInput) module.quantityInput.value = state.quantity;
          if (module.quantityDisplay) module.quantityDisplay.textContent = state.quantity;
        }

        // Restore customizations
        if (state.customizations && Array.isArray(state.customizations)) {
          module.customizations = JSON.parse(JSON.stringify(state.customizations));
        }

        // After restoring customizations, update module's primary display
        // based on the first customization item.
        if (module.customizations.length > 0) {
          const firstCustomization = module.customizations[0];

          if (firstCustomization.variantId) {
            const variant = module.variants.find(v => v.id === firstCustomization.variantId);
            if (variant) {
              module.currentVariant = variant;
              module.productId = variant.id;

              let basePrice = variant.price;

              if (firstCustomization.extraVariants) {
                this.extraVariantsSelections.set(handle, firstCustomization.extraVariants);
                firstCustomization.extraVariants.forEach(ev => {
                  basePrice += (ev.price * 100);
                });
              }
              module.productPrice = basePrice;
              module.productComparePrice = variant.compare_at_price || 0;
            }
          }
          this.syncAccordionWithCurrentVariant(module);
        }

        this.toggleQuantityDisplay(module);
        this.updateModulePriceDisplay(module);

        if (module.quantity > 1 && module.variants && module.variants.length > 1) {
          setTimeout(() => {
            this.openAccordion(handle, { openFirstDropdown: false });
            this.updateModuleQuantityLines(handle);
          }, 150);
        }
      });

      this.updateMainProductPrice();
      this.updateAddToCartButtonState();
    } catch (e) {
      console.warn('Failed to load bundle state from storage:', e);
    }
  }

  saveModuleState() {
    const moduleState = {};
    this.modules.forEach((module, handle) => {
      moduleState[handle] = {
        quantity: module.quantity,
        customizations: module.customizations || []
      };
    });

    this.saveStateToStorage(this.sessionStorageKey, moduleState);
  }
}

// Initialize
const initializeBundleCustomizer = function () {
  try {
    const bundleCustomizerElements = document.querySelectorAll('[data-bundle-customizer]');
    bundleCustomizerElements.forEach(customizer => {
      if (!customizer._bundleCustomizerInstance) {
        new BundleProductCustomizer(customizer);
      }
    });
  } catch (error) {
    console.error('Error initializing Bundle Customizer:', error);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBundleCustomizer);
} else {
  initializeBundleCustomizer();
}

document.addEventListener('shopify:section:load', initializeBundleCustomizer);
document.addEventListener('shopify:section:select', initializeBundleCustomizer);
document.addEventListener('shopify:block:select', initializeBundleCustomizer); 